import React from "react";
import { Link, useNavigate } from "react-router-dom";

interface BlogCardProps {
    data: any;
    isLoading: boolean;
}

const BlogCard: React.FC<BlogCardProps> = (props) => {

    const truncateContent = (content: string, maxLength: number) => {
        if (!content) return "";
        const plainText = content.replace(/(<([^>]+)>)/gi, "");
        return plainText.length > maxLength
            ? plainText.substring(0, maxLength) + "..."
            : plainText;
    };
    const truncatedHTML = truncateContent(props.data?.content, 70);
    const navigate = useNavigate();

    const handleClick = () => {
        navigate(`/blog/${props.data?._id}`, { state: { data: props.data } });
    };

    return (
        <div className="isotope-item col-lg-4 col-md-6 col-sm-12">
            <article className="vertical-item content-padding mosaic-post post format-standard text-center with_background">
                <div className="item-media entry-thumbnail">
                    <img src={props.data?.resim} style={{
                        height: 'auto',
                        objectFit: 'contain'
                    }}
                    />
                </div>
                <div className="item-content entry-content">
                    <header className="entry-header">
                        <span className="small-text big-spacing">
                            <time dateTime="2016-01-10T15:05:23+00:00" className="entry-date">
                                {props.data?.tarih}
                            </time>
                        </span>
                        <h3 className="entry-title">
                            <a href="#" rel="bookmark">{props.data?.title}</a>
                        </h3>
                    </header>
                    {/* .entry-header */}
                    <p dangerouslySetInnerHTML={{ __html: truncatedHTML }}></p>
                    <br />
                    <button className="theme_button color2" onClick={handleClick}  >Devamını Oku</button>

                </div>
                {/* .item-content.entry-content */}
            </article>
        </div>
    )
}

export default BlogCard;